(ns common.schema.entities.survey.survey-question-external-id
  (:require
   [common.schema.schema-utils :as su]))

(def schema
  (concat
   ;;named value or string list
   ;;config in field settings by tenant admin
   (su/option-field :survey-question-ext-id/question-battery
                    "Question battery"
                    {:authorization            su/access-user-user
                     :default-field-visibility :in-use-disabled})
   (su/text-simple-field :survey-question-ext-id/external-id
                         "Ext ID"
                         {:authorization            su/access-user-user
                          :default-field-visibility :in-use-disabled})))

